import { CurrentUser } from "@teamprevent/common/model";

import { CUSTOMER_ROLES } from "../auth/model";

export class MessagingAuthorizer {
    public static isAuthorized = (user: CurrentUser) => {
        const validRoles: string[] = [
            CUSTOMER_ROLES.manager.name,
            CUSTOMER_ROLES.hr.name,
            CUSTOMER_ROLES.recruitmentManager.name,
            CUSTOMER_ROLES.caseManager.name,
            CUSTOMER_ROLES.customerAdministrator.name
        ];
        const roles = user.roles;

        return roles?.some(r =>  validRoles.includes(r));
    };
}
